import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-route-geometry-changes',
  imports: [],
  templateUrl: './route-geometry-changes.component.html',
  styleUrl: './route-geometry-changes.component.scss',
})
export class RouteGeometryChangesComponent {

  @Input() set geometryChanges(value: any) {
    this.newRouteCount = value?.newRouteIds?.length;
    this.removedRouteCount = value?.removedRouteIds?.length;
    this.changedRouteCount = value?.changedRoutes?.length;
  }
  newRouteCount: number;
  removedRouteCount: number;
  changedRouteCount: number;
}
